<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :query="query"
      :selection="false"
      :toolbar="toolbar"
      label-width="120px"
    />
  </div>
</template>

<script>
import { HOST, EV_HOST } from '@/utils/host'
import fieldFilter from '@/utils/fieldFilter.js'
export default {
  name: 'Zhanghufuzhigaojing',
  components: {},
  data() {
    return {
      url: '/alarm/alarmRecord/pageUser',
      columns: [
        {
          label: '充电单号',
          prop: 'startChargeSeq'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '车牌号码',
          prop: 'plateNumber'
        },
        {
          label: '归属企业',
          prop: 'orgName'
        },
        {
          label: '告警时间',
          prop: 'createDate'
        },
        {
          label: '短信',
          prop: 'isSendSMS',
          template: (index, record) => {
            return record.isSendSMS ? '是' : '否'
          }
        },
        {
          label: '停充',
          prop: 'isStopCharging',
          template: (index, record) => {
            return record.isStopCharging ? '是' : '否'
          }
        },
        {
          label: '账户负值（元）',
          prop: 'actualValue',
          template: (index, record) => {
            return record.actualValue ? record.actualValue.toFixed(2) : ''
          }
        }
      ],
      query: [
        {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        },
        {
          label: '归属企业',
          prop: 'orgName',
          placeholder: '请输入归属企业'
        },
        {
          label: '车牌号码',
          prop: 'plateNumber',
          placeholder: '请输入车牌号码'
        },
        {
          label: '充电单号',
          prop: 'startChargeSeq',
          placeholder: '请输入充电单号'
        },
        {
          label: '短信通知',
          prop: 'isSendSMS',
          placeholder: '请选择短信通知',
          type: 'select',
          data: [{
            value: true,
            label: '是'
          }, {
            value: false,
            label: '否'
          }]
        },
        {
          label: '是否停充',
          prop: 'isStopCharging',
          placeholder: '请选择是否停充',
          type: 'select',
          data: [{
            value: true,
            label: '是'
          }, {
            value: false,
            label: '否'
          }]
        },
        {
          label: '告警时间',
          placeholder: '',
          prop: 'startDateTime',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '导出',
		  icon: 'el-icon-download',
          permission: 'alarm.negative.export',
          type: 'primary',
          handle: resp => {
            const url = HOST + '/alarm/alarmRecord/pageUser?isExport=true'
            const queryData = this.$refs.tableref.getQueryData()
            queryData.token = window.localStorage.getItem('token')
            queryData.companyId = window.localStorage.getItem('curCompanyId')
            $.fileDownload(url, {
              httpMethod: 'get',
              data: queryData,
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/alarmManagement/negativeValueAlarm.vue